import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { buildInfo } from 'src/environments/build-info.generated';
import { environment } from 'src/environments/environment';
import { QuicksearchService } from '../services/data/quicksearch.service';
import { ParkerStateService } from '../services/state/parker-state.service';

@Component({
  selector: 'app-nav-sidebar',
  templateUrl: './nav-sidebar.component.html',
  styleUrl: './nav-sidebar.component.scss',
})
export class NavSidebarComponent implements OnInit {
  mainApnUrl: string = '';
  lastbuildDate: string = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(new Date(buildInfo.lastBuildDate));

  private _routerService = inject(Router);
  public _appGeneralState = inject(AppGeneralStateService);
  private _quickSearchService = inject(QuicksearchService);
  private _parkerStateService = inject(ParkerStateService);

  constructor() {
    this.mainApnUrl = environment.AceParkUrl;
  }

  ngOnInit(): void {}

  onNavTo_(): void {
    window.location.href = `https://${this.mainApnUrl}/`;
  }

  onNavToGB(): void {
    window.location.href = `https://${this.mainApnUrl}/Invoice/GenerateBilling`;
  }

  onNavToMI(): void {
    window.location.href = `https://${this.mainApnUrl}/Invoice/ManualInvoice`;
  }

  onNavToReports(): void {
    window.location.href = `https://${this.mainApnUrl}/Reports`;
  }

  onNavToLegacySendInvoices(): void {
    window.location.href = `https://${this.mainApnUrl}/Invoice/SendEmailSetup`;
  }

  onNavToMarketRates(): void {
    window.location.href = `https://${this.mainApnUrl}/Utilities`;
  }

  onNavToCompanyRates(): void {
    window.location.href = `https://${this.mainApnUrl}/Utilities/CompanyRates`;
  }

  onNavToLegacyLotSetup(): void {
    window.location.href = `https://${this.mainApnUrl}/Admin/SetupLot`;
  }

  onNavToCompanyProfile(): void {
    this._quickSearchService.resetClearDataStructures();
    this._parkerStateService.resetQueryData();
    this._routerService.navigate(['companylist']);
  }

  onNavToParkerProfile(): void {
    this._quickSearchService.resetClearDataStructures();
    this._parkerStateService.resetQueryData();
    this._routerService.navigate(['parkerlist']);
  }

  onNavToNewParkerProfile(): void {
    this._quickSearchService.resetClearDataStructures();
    this._parkerStateService.resetQueryData();
    this._routerService.navigate(['parkerv2']);
  }

  onNavToInvoiceSearch(): void {
    this._quickSearchService.resetClearDataStructures();
    this._parkerStateService.resetQueryData();
    this._routerService.navigate(['quicksearch']);
  }

  onNavToAdminParkerAgreementSetup(): void {
    this._routerService.navigate(['adminhome/1/parkeragreementtemplate']);
  }

  onNavToLotSetup(): void {
    this._routerService.navigate(['utilities/lotsetup']);
  }

  onNavToParcsSyncSetup(): void {
    this._routerService.navigate(['utilities/parcssyncsetup']);
  }

  onNavToFlashParkingSyncSetup(): void {
    this._routerService.navigate(['utilities/flashparkingsyncsetup']);
  }

  onNavToFlashParkingUtilities(): void {
    this._routerService.navigate(['utilities/flashparkingutilities']);
  }
}
